<script lang="ts">
export default {
  name: 'KkAddLabel',
}
</script>

<script setup lang="ts">
import { KkIcon } from '../../base'

interface Props {
  label: string
  disabled?: boolean
}

interface Emits {
  (e: 'click', value: MouseEvent): void
}

const props = withDefaults(defineProps<Props>(), {
  label: '',
  disabled: false
})

const emit = defineEmits<Emits>()

const onClick = ($event: MouseEvent) => {
  if (props.disabled) return
  emit('click', $event)
}

</script>

<template>
  <button type="button" class="addLabel" :class="{ 'addLabel--disabled': disabled }" @click="onClick($event)">
    <div class="addLabel__icon">
      <KkIcon name="add" color="#E9446A" />
    </div>
    <div class="addLabel__text">
      {{ label }}
    </div>
  </button>
</template>

<style lang="scss" scoped>
@import '../../../../../stylesheets/biz_spa/foundation/_var.scss';
@import '../../../../../stylesheets/biz_spa/foundation/_mixin.scss';
.addLabel {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
  &__icon {
    flex: 0 0 16px;
    min-width: 16px;
  }
  &__text {
    margin-left: 10px;
    color: #E9446A;
    font-size: 12px;
    line-height: 1.5;
  }
  &--disabled {
    cursor: not-allowed;
  }
}
</style>
